import type { Message } from 'pages/ParentHelper/types';

export const transformChatData = (messages: Message[]) =>
  messages.map((message, index, array) =>
    (!message.question || !message.answer) && index !== array.length - 1
      ? { ...message, withoutAvatar: true }
      : message,
  );
